var map = {
	"./Hero.png": 9883,
	"./Logo Ex-1.png": 3220,
	"./Logo Ex-2.png": 5857,
	"./Logo Ex-3.png": 3655,
	"./Logo Ex-4.png": 7902,
	"./Logo Ex-5.png": 4214,
	"./Logo Ex-6.png": 9301,
	"./Logo Ex-7.png": 2732,
	"./Logo Ex.png": 5648,
	"./believe.svg": 7737,
	"./hand.svg": 7190,
	"./hero.gif": 4547,
	"./logo-40ani.png": 6295,
	"./trust.svg": 8716
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2975;